import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center cursor-pointer" }

import { Field } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxField',
  props: {
  label: {
    type: String,
    required: true,
  },
  labelFontWeight: {
    type: Number,
    default: 500,
  },
  name: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: false,
  },
  value: {
    type: [Boolean, String],
    required: false,
  },
  isMinusIcon: {
    type: Boolean,
    required: false,
  },
  isChecked: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    (__props.isMinusIcon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'h-4 w-4 rounded  flex items-center justify-center select-none',
        __props.isChecked ? 'bg-yellow-600 text-white' : 'bg-white text-yellow-600',
      ])
        }, _toDisplayString(__props.isChecked ? "+" : "-"), 3))
      : _createCommentVNode("", true),
    _createVNode(_unref(Field), {
      name: __props.name,
      type: "checkbox",
      class: _normalizeClass([
        'h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500',
        { hidden: __props.isMinusIcon },
      ]),
      "unchecked-value": false,
      value: __props.value || true,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event)))
    }, null, 8, ["name", "class", "value"]),
    _createElementVNode("p", {
      class: "ml-3 text-sm text-gray-700 truncate",
      style: _normalizeStyle(`font-weight: ${__props.labelFontWeight};`)
    }, _toDisplayString(__props.label), 5)
  ]))
}
}

})